(() => {
  'use strict';
  const share = document.getElementById('share');
  const copy = document.getElementById('copy');
  const message = document.getElementById('message');
  const status = document.getElementById('status');
  const reveal = () => {
    document.getElementById('invitation').open = true;
    message.focus();
    message.select();
    status.textContent = 'Copy the selected invitation and paste it into your message.';
  };
  copy.hidden = false;
  share.hidden = typeof navigator.share !== 'function';
  (share.hidden ? copy : share).classList.add('primary');
  if (!share.hidden) document.getElementById('invitation').append(copy);
  copy.addEventListener('click', async () => {
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(message.value);
      status.textContent = 'Invitation copied. Paste it into a message to your friend.';
    } catch { reveal(); }
  });
  share.addEventListener('click', async () => {
    status.textContent = '';
    try { await navigator.share({title: 'Come dance with me at HIT', text: message.value}); }
    catch (error) {
      if (error.name !== 'AbortError') {
        document.getElementById('invitation').open = true;
        status.textContent = 'Use Copy invitation below to share your message.';
      }
    }
  });
})();
